{
  "familyId": "TAA-SOORT-LID",
  "questions": [
    {
      "id": "TAA-SOORT-LID-001",
      "familyId": "TAA-SOORT-LID",
      "module": "Taalbegrip",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "woordsoorten",
      "subSkill": "srt_lid_znw",
      "questionType": "multiple_choice",
      "question": "Een corrector controleert een tekst. Welk woord is een zelfstandig naamwoord in deze zin? 'De kat slaapt op de bank.'",
      "context": null,
      "options": ["kat", "slaapt", "op", "de"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "data": { "title": "Zelfstandig naamwoord herkennen", "content": "Een zelfstandig naamwoord is een woord voor een persoon, dier, ding of begrip. Je kunt er vaak 'de' of 'het' voor zetten. Test: de kat ✓, de slaapt ✗, de op ✗.", "icon": "lightbulb" }, "showWhen": "wrong" }],
      "conceptId": "noun_identification",
      "variantIndex": 1,
      "citoDifficulty": 0.15,
      "citoDiscrimination": 0.83,
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "taa.verb-as-noun", "label": "Verwart werkwoord met zelfstandig naamwoord", "optionIndex": 1 },
          { "id": "taa.preposition-as-noun", "label": "Verwart voorzetsel met zelfstandig naamwoord", "optionIndex": 2 },
          { "id": "taa.article-as-noun", "label": "Verwart lidwoord met zelfstandig naamwoord", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "Een zelfstandig naamwoord is een woord voor een persoon, dier, ding of begrip — je kunt er 'de' of 'het' voor zetten. Test elk woord: de kat ✓ (dier), de slaapt ✗, de op ✗, de de ✗. 'Kat' is een dier → zelfstandig naamwoord. (Let op: 'bank' is ook een zelfstandig naamwoord in deze zin.)",
        "solutionSteps": [
          "Test elk woord met 'de' of 'het' ervoor",
          "de kat ✓ (dier) → zelfstandig naamwoord",
          "de slaapt ✗ → werkwoord",
          "de op ✗ → voorzetsel",
          "'Kat' is een zelfstandig naamwoord"
        ],
        "distractorExplanations": {
          "0": "Goed! 'Kat' is een zelfstandig naamwoord: het is een dier en je kunt er 'de' voor zetten (de kat).",
          "1": "Je dacht waarschijnlijk dat een werkwoord een zelfstandig naamwoord is. Maar 'slaapt' is een werkwoord (persoonsvorm) — het geeft een handeling aan. Onthoud: test met 'de/het' ervoor: 'de slaapt' klinkt fout.",
          "2": "Je dacht waarschijnlijk dat een voorzetsel een zelfstandig naamwoord is. Maar 'op' is een voorzetsel dat een relatie aangeeft (waar?). Onthoud: test met 'de/het' ervoor: 'de op' klinkt fout.",
          "3": "Je dacht waarschijnlijk dat een lidwoord een zelfstandig naamwoord is. Maar 'de' is een lidwoord dat vóór het zelfstandig naamwoord staat. Onthoud: het zelfstandig naamwoord is het woord erna: kat."
        }
      }
    },
    {
      "id": "TAA-SOORT-LID-002",
      "familyId": "TAA-SOORT-LID",
      "module": "Taalbegrip",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "woordsoorten",
      "subSkill": "srt_lid_znw",
      "questionType": "multiple_choice",
      "question": "Een vertaler zoekt het juiste lidwoord. Welk lidwoord hoort bij het woord 'huis'?",
      "context": null,
      "options": ["het", "de", "een (alleen)", "geen lidwoord"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "data": { "title": "De of het?", "content": "In het Nederlands zijn er twee bepaalde lidwoorden: 'de' en 'het'. 'Het' gebruik je bij onzijdige woorden (het-woorden). 'Huis' is een het-woord: het huis.", "icon": "lightbulb" }, "showWhen": "wrong" }],
      "conceptId": "article_het_de",
      "variantIndex": 2,
      "citoDifficulty": 0.18,
      "citoDiscrimination": 0.81,
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "taa.de-het-confused", "label": "Verwart de-woord met het-woord", "optionIndex": 1 },
          { "id": "taa.article-only-een", "label": "Denkt dat alleen 'een' een lidwoord is", "optionIndex": 2 },
          { "id": "taa.no-article-needed", "label": "Denkt dat woorden geen lidwoord hebben", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "Je moet per woord onthouden of het een de-woord of een het-woord is. 'Huis' is een het-woord → het huis. In het meervoud krijgen alle woorden 'de': de huizen. Tip: verkleinwoorden zijn altijd het-woorden (het huisje).",
        "solutionSteps": [
          "'Huis' is een het-woord → het huis",
          "In het meervoud: de huizen",
          "Verkleinwoord: het huisje (altijd 'het')"
        ],
        "distractorExplanations": {
          "0": "Goed! 'Huis' is een het-woord: het huis.",
          "1": "Je dacht waarschijnlijk dat 'huis' een de-woord is. Maar je zegt 'het huis', niet 'de huis'. Onthoud: dit moet je per woord onthouden. Tip: verkleinwoorden zijn altijd het-woorden (het huisje).",
          "2": "Je dacht waarschijnlijk dat 'een' het enige lidwoord is. Maar 'een' is het onbepaalde lidwoord (een huis). Onthoud: de vraag is naar het bepaalde lidwoord, en bij 'huis' is dat 'het'.",
          "3": "Je dacht waarschijnlijk dat een woord geen lidwoord heeft. Maar 'huis' is een zelfstandig naamwoord en heeft altijd een lidwoord: het huis (bepaald) of een huis (onbepaald). Onthoud: elk zelfstandig naamwoord heeft een lidwoord."
        }
      }
    },
    {
      "id": "TAA-SOORT-LID-003",
      "familyId": "TAA-SOORT-LID",
      "module": "Taalbegrip",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "woordsoorten",
      "subSkill": "srt_lid_znw",
      "questionType": "multiple_choice",
      "question": "Een basisschooldocent stelt een vraag aan de klas. Hoeveel zelfstandige naamwoorden staan er in deze zin? 'De jongen gooit de bal in de tuin.'",
      "context": null,
      "options": ["3", "2", "1", "4"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "data": { "title": "Zelfstandige naamwoorden tellen", "content": "Zoek alle woorden voor personen, dieren, dingen of begrippen. In deze zin: jongen (persoon), bal (ding), tuin (ding) = 3 zelfstandige naamwoorden.", "icon": "lightbulb" }, "showWhen": "wrong" }],
      "conceptId": "noun_counting",
      "variantIndex": 3,
      "citoDifficulty": 0.22,
      "citoDiscrimination": 0.79,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "taa.noun-undercount", "label": "Telt te weinig zelfstandige naamwoorden", "optionIndex": 1 },
          { "id": "taa.noun-undercount", "label": "Telt maar 1 zelfstandig naamwoord", "optionIndex": 2 },
          { "id": "taa.noun-overcount", "label": "Telt niet-naamwoorden mee", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "Zoek alle woorden voor personen, dieren, dingen of begrippen — test met 'de/het'. De jongen ✓ (persoon), de bal ✓ (ding), de tuin ✓ (ding). Totaal: 3 zelfstandige naamwoorden. 'Gooit' (werkwoord) en 'in' (voorzetsel) zijn geen zelfstandige naamwoorden.",
        "solutionSteps": [
          "Test elk woord: de jongen ✓ (persoon)",
          "de bal ✓ (ding)",
          "de tuin ✓ (ding)",
          "Totaal: 3 zelfstandige naamwoorden"
        ],
        "distractorExplanations": {
          "0": "Goed! Er staan 3 zelfstandige naamwoorden: jongen, bal en tuin.",
          "1": "Je dacht waarschijnlijk dat er maar 2 zijn. Bij 2 vergeet je waarschijnlijk 'jongen' (persoon) of 'tuin' (ding). Onthoud: test elk woord met 'de/het' ervoor om ze allemaal te vinden.",
          "2": "Je dacht waarschijnlijk dat er maar 1 is. Maar er zijn 3 zelfstandige naamwoorden: jongen, bal en tuin. Onthoud: een zin kan meerdere zelfstandige naamwoorden bevatten.",
          "3": "Je dacht waarschijnlijk dat er 4 zijn. Maar er zijn 3, niet 4 zelfstandige naamwoorden. Onthoud: 'gooit' is een werkwoord, 'in' is een voorzetsel, en 'de' is een lidwoord — die tellen niet mee."
        }
      }
    },
    {
      "id": "TAA-SOORT-LID-004",
      "familyId": "TAA-SOORT-LID",
      "module": "Taalbegrip",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "woordsoorten",
      "subSkill": "srt_lid_znw",
      "questionType": "multiple_choice",
      "question": "Een bibliothecaris sorteert boeken. Welk woord is een lidwoord in deze zin? 'Een vogel zingt in het bos.'",
      "context": null,
      "options": ["Een", "vogel", "zingt", "bos"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "data": { "title": "Lidwoorden herkennen", "content": "Lidwoorden staan vóór een zelfstandig naamwoord. Er zijn drie lidwoorden: de, het, een. In deze zin: 'Een' staat voor 'vogel' en 'het' staat voor 'bos'.", "icon": "lightbulb" }, "showWhen": "wrong" }],
      "conceptId": "article_identification",
      "variantIndex": 4,
      "citoDifficulty": 0.16,
      "citoDiscrimination": 0.82,
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "taa.noun-as-article", "label": "Verwart zelfstandig naamwoord met lidwoord", "optionIndex": 1 },
          { "id": "taa.verb-as-article", "label": "Verwart werkwoord met lidwoord", "optionIndex": 2 },
          { "id": "taa.noun-as-article", "label": "Verwart zelfstandig naamwoord met lidwoord", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "Lidwoorden staan altijd vóór een zelfstandig naamwoord. Er zijn drie lidwoorden in het Nederlands: de, het, een. 'Een' staat voor 'vogel' → lidwoord ✓. 'Het' staat voor 'bos' → ook een lidwoord. 'Een' is het onbepaalde lidwoord (je weet niet welke vogel).",
        "solutionSteps": [
          "Ken de drie lidwoorden: de, het, een",
          "'Een' staat voor 'vogel' → lidwoord ✓",
          "'Het' staat voor 'bos' → ook een lidwoord",
          "'Een' is het onbepaalde lidwoord"
        ],
        "distractorExplanations": {
          "0": "Goed! 'Een' is een onbepaald lidwoord. Het staat voor het zelfstandig naamwoord 'vogel'.",
          "1": "Je dacht waarschijnlijk dat een zelfstandig naamwoord een lidwoord is. Maar 'vogel' is een zelfstandig naamwoord (een dier). Onthoud: het lidwoord staat ervóór: een vogel.",
          "2": "Je dacht waarschijnlijk dat een werkwoord een lidwoord is. Maar 'zingt' is een werkwoord (persoonsvorm). Onthoud: lidwoorden zijn alleen: de, het, een.",
          "3": "Je dacht waarschijnlijk dat een zelfstandig naamwoord een lidwoord is. Maar 'bos' is een zelfstandig naamwoord (een ding/plek). Onthoud: het lidwoord staat ervóór: het bos."
        }
      }
    },
    {
      "id": "TAA-SOORT-LID-005",
      "familyId": "TAA-SOORT-LID",
      "module": "Taalbegrip",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "woordsoorten",
      "subSkill": "srt_lid_znw",
      "questionType": "multiple_choice",
      "question": "Een journalist schrijft een artikel. Welk woord is het werkwoord in deze zin? 'De fietser rijdt over de brug.'",
      "context": null,
      "options": ["rijdt", "fietser", "brug", "over"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "data": { "title": "Werkwoord herkennen", "content": "Een werkwoord is een doe-woord: het geeft een handeling of toestand aan. Test: wat doet de fietser? De fietser rijdt. 'Rijdt' is het werkwoord (persoonsvorm).", "icon": "lightbulb" }, "showWhen": "wrong" }],
      "conceptId": "verb_identification",
      "variantIndex": 5,
      "citoDifficulty": 0.20,
      "citoDiscrimination": 0.80,
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "taa.agent-noun-as-verb", "label": "Verwart persoonsnaam (-er) met werkwoord", "optionIndex": 1 },
          { "id": "taa.noun-as-verb", "label": "Verwart zelfstandig naamwoord met werkwoord", "optionIndex": 2 },
          { "id": "taa.preposition-as-verb", "label": "Verwart voorzetsel met werkwoord", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "Een werkwoord is een doe-woord — het geeft een handeling of toestand aan. Stel de vraag: wat doet de fietser? De fietser rijdt. 'Rijdt' geeft de handeling aan → werkwoord (persoonsvorm). De andere woorden: 'fietser' = persoon (znw), 'brug' = ding (znw), 'over' = voorzetsel.",
        "solutionSteps": [
          "Stel de vraag: wat doet de fietser?",
          "De fietser rijdt → 'rijdt' is de handeling",
          "'Rijdt' is het werkwoord (persoonsvorm)",
          "Check: fietser = znw, brug = znw, over = voorzetsel"
        ],
        "distractorExplanations": {
          "0": "Goed! 'Rijdt' is het werkwoord (persoonsvorm) — het geeft de handeling aan.",
          "1": "Je dacht waarschijnlijk dat 'fietser' het werkwoord is. Maar 'fietser' is een zelfstandig naamwoord (een persoon). Het lijkt op 'fietsen', maar de -er maakt het een persoon. Onthoud: stel de vraag 'wat doet hij?' → rijdt.",
          "2": "Je dacht waarschijnlijk dat 'brug' het werkwoord is. Maar 'brug' is een zelfstandig naamwoord (een ding). Onthoud: een werkwoord geeft een handeling aan, een zelfstandig naamwoord is een persoon, dier of ding.",
          "3": "Je dacht waarschijnlijk dat 'over' het werkwoord is. Maar 'over' is een voorzetsel dat aangeeft waar iets gebeurt (over de brug). Onthoud: een werkwoord geeft een handeling aan: rijdt."
        }
      }
    },
    {
      "id": "TAA-SOORT-LID-006",
      "familyId": "TAA-SOORT-LID",
      "module": "Taalbegrip",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "woordsoorten",
      "subSkill": "srt_lid_znw",
      "questionType": "matching",
      "question": "Koppel elk zelfstandig naamwoord aan het juiste lidwoord (de of het).",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "pairs": [
          { "left": "huis", "right": "het" },
          { "left": "tafel", "right": "de" },
          { "left": "boek", "right": "het" },
          { "left": "stoel", "right": "de" }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "De of het?",
            "content": "Je moet per woord onthouden of het een de-woord of het-woord is. Het huis, de tafel, het boek, de stoel. Tip: verkleinwoorden zijn altijd het-woorden (het huisje, het tafeltje).",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "lidwoord_matching_de_het",
      "variantIndex": 6,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.74,
      "pedagogy": { "dok": 1 },
      "feedback": {
        "explanationText": "Het huis (het-woord), de tafel (de-woord), het boek (het-woord), de stoel (de-woord). Dit moet je per woord onthouden.",
        "solutionSteps": [
          "Huis → het huis (het-woord)",
          "Tafel → de tafel (de-woord)",
          "Boek → het boek (het-woord)",
          "Stoel → de stoel (de-woord)"
        ]
      }
    },
    {
      "id": "TAA-SOORT-LID-007",
      "familyId": "TAA-SOORT-LID",
      "module": "Taalbegrip",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "woordsoorten",
      "subSkill": "srt_lid_znw",
      "questionType": "matching",
      "question": "Koppel elk woord aan de juiste woordsoort.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "pairs": [
          { "left": "de", "right": "lidwoord" },
          { "left": "hond", "right": "zelfstandig naamwoord" },
          { "left": "rent", "right": "werkwoord" },
          { "left": "snel", "right": "bijvoeglijk naamwoord" }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Woordsoorten herkennen",
            "content": "Lidwoord = de, het, een (staat voor een znw). Zelfstandig naamwoord = persoon/dier/ding. Werkwoord = doe-woord. Bijvoeglijk naamwoord = eigenschap.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "lidwoord_matching_woordsoorten",
      "variantIndex": 7,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.73,
      "pedagogy": { "dok": 1 },
      "feedback": {
        "explanationText": "De = lidwoord (staat voor 'hond'). Hond = zelfstandig naamwoord (een dier). Rent = werkwoord (wat doet de hond?). Snel = bijvoeglijk naamwoord (hoe is de hond?).",
        "solutionSteps": [
          "De → lidwoord (de, het, een)",
          "Hond → zelfstandig naamwoord (dier)",
          "Rent → werkwoord (handeling)",
          "Snel → bijvoeglijk naamwoord (eigenschap)"
        ]
      }
    },
    {
      "id": "TAA-SOORT-LID-008",
      "familyId": "TAA-SOORT-LID",
      "module": "Taalbegrip",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "woordsoorten",
      "subSkill": "srt_lid_znw",
      "questionType": "matching",
      "question": "Koppel elk woord aan de juiste categorie: de-woord of het-woord.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "pairs": [
          { "left": "kind", "right": "het" },
          { "left": "school", "right": "de" },
          { "left": "meisje", "right": "het" },
          { "left": "leraar", "right": "de" }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "De of het? Tips",
            "content": "Het kind, de school, het meisje, de leraar. Tip: verkleinwoorden (-je, -tje) zijn altijd het-woorden. 'Meisje' is een verkleinwoord → het meisje.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "lidwoord_matching_de_het_personen",
      "variantIndex": 8,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.72,
      "pedagogy": { "dok": 1 },
      "feedback": {
        "explanationText": "Het kind (het-woord), de school (de-woord), het meisje (het-woord — verkleinwoord!), de leraar (de-woord).",
        "solutionSteps": [
          "Kind → het kind (het-woord)",
          "School → de school (de-woord)",
          "Meisje → het meisje (verkleinwoord → altijd het)",
          "Leraar → de leraar (de-woord)"
        ]
      }
    },
    {
      "id": "TAA-SOORT-LID-009",
      "familyId": "TAA-SOORT-LID",
      "module": "Taalbegrip",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "woordsoorten",
      "subSkill": "srt_lid_znw",
      "questionType": "categorize",
      "question": "Sorteer de woorden: is het een zelfstandig naamwoord, werkwoord of lidwoord?",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "categories": ["Zelfstandig naamwoord", "Werkwoord", "Lidwoord"],
        "items": [
          { "text": "hond", "correctCategory": 0 },
          { "text": "rent", "correctCategory": 1 },
          { "text": "de", "correctCategory": 2 },
          { "text": "boom", "correctCategory": 0 },
          { "text": "zingt", "correctCategory": 1 },
          { "text": "het", "correctCategory": 2 }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Woordsoorten herkennen", "content": "Zelfstandig naamwoord = persoon, dier, ding (hond, boom). Werkwoord = doe-woord (rent, zingt). Lidwoord = de, het, een.", "icon": "lightbulb" } }
      ],
      "conceptId": "woordsoorten_categorize",
      "variantIndex": 9,
      "citoDifficulty": 0.22,
      "citoDiscrimination": 0.78,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "Zelfstandige naamwoorden (dieren/dingen): hond, boom. Werkwoorden (handelingen): rent, zingt. Lidwoorden: de, het.",
        "solutionSteps": [
          "Hond → dier → zelfstandig naamwoord",
          "Rent → handeling → werkwoord",
          "De → lidwoord",
          "Boom → ding → zelfstandig naamwoord",
          "Zingt → handeling → werkwoord",
          "Het → lidwoord"
        ]
      }
    },
    {
      "id": "TAA-SOORT-LID-010",
      "familyId": "TAA-SOORT-LID",
      "module": "Taalbegrip",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "woordsoorten",
      "subSkill": "srt_lid_znw",
      "questionType": "true_false_series",
      "question": "Beoordeel elke stelling: waar of niet waar?",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "statements": [
          { "text": "'Huis' is een het-woord.", "isTrue": true },
          { "text": "'De' is een zelfstandig naamwoord.", "isTrue": false },
          { "text": "Een verkleinwoord is altijd een het-woord.", "isTrue": true },
          { "text": "'Tafel' is een het-woord.", "isTrue": false },
          { "text": "In het meervoud krijgen alle woorden 'de'.", "isTrue": true }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "De of het — regels", "content": "Het huis (het-woord). 'De' is een lidwoord, geen znw. Verkleinwoorden (-je, -tje) zijn altijd het-woorden. De tafel (de-woord). In het meervoud: altijd 'de' (de huizen, de tafels).", "icon": "lightbulb" } }
      ],
      "conceptId": "lidwoord_true_false",
      "variantIndex": 10,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.76,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "'Huis' = het huis ✓. 'De' = lidwoord, geen znw ✗. Verkleinwoorden = altijd het ✓. 'Tafel' = de tafel (de-woord) ✗. Meervoud = altijd 'de' ✓.",
        "solutionSteps": [
          "'Huis' → het huis → WAAR",
          "'De' → lidwoord, geen znw → NIET WAAR",
          "Verkleinwoord → altijd het → WAAR",
          "'Tafel' → de tafel → NIET WAAR",
          "Meervoud → altijd 'de' → WAAR"
        ]
      }
    }
  ]
}